/* eslint-disable react/prop-types */
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import Form from "components/Forms/FormContainer";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import TableHeader from "components/Tables/TableHeader";
import React from "react";
import styles from "assets/jss/material-dashboard-pro-react/components/formStyle (temp)";
import CustomInput from "components/Inputs/CustomInput";
import { makeStyles } from "@material-ui/core";
import { isEmpty } from "helpers/validations";
import CustomFormSelect from "components/Selects/CustomSelect";
import { isNumber } from "helpers/validations";
import {
  AREA_TYPES,
  INPUT_TYPES,
  INPUT_VALIDATIONS,
} from "constants/defaultValues";
import InputOptions from "components/Inputs/InputOptions";

const useStyles = makeStyles(styles);

const CustomMetricsFields = ({
  fields,
  setFields,
  prerequisiteValue,
  AreFieldsValidated,
  inquiryMenu,
  isedit = false,
}) => {
  const classes = useStyles();

  // this useEffect is cleaning the input options if the user accidentally selects checkbox or radio
  React.useEffect(() => {
    if (
      fields.Type.toLowerCase() === "rating" &&
      fields.CheckBoxOptions &&
      fields.CheckBoxOptions.length > 0
    ) {
      const newFields = { ...fields };
      newFields.CheckBoxOptions = [];
      setFields(newFields);
    } else if (
      fields.Type.toLowerCase() === "checkbox" &&
      fields.RadioButtonOptions &&
      fields.RadioButtonOptions.length > 0
    ) {
      const newFields = { ...fields };
      newFields.RadioButtonOptions = [];
      setFields(newFields);
    }
  }, [fields, fields.Type]);

  // this useEffect will select Rating input field if the user selects any area other than "Others"
  // client wants rating to be input field for every area field except for 'Others'
  // the input field will be locked when the input type is rating so that the user can only enter rating for any Areas other than "Others"
  React.useEffect(() => {
    if (fields.Area && fields.Area !== "Other") {
      setFields({ ...fields, Type: "Rating" });
    }
  }, [fields.Area]);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader>
            <TableHeader
              title={prerequisiteValue.title}
              btnText={prerequisiteValue.btnAccept}
              btnText2={prerequisiteValue.btnReject}
              showBackButton
              onClick={() => prerequisiteValue.Approve()}
              onClick2={() => prerequisiteValue.Reject()}
              goBackRoute={prerequisiteValue.goBackLink}
            />
          </CardHeader>
          <CardBody>
            <Form height>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomFormSelect
                    inputType="text"
                    required
                    label="Area"
                    value={fields.Area}
                    menu={AREA_TYPES}
                    customClassName={classes.textFieldSelectStyling}
                    onChange={(event) => {
                      setFields({
                        ...fields,
                        Area: event.target.value,
                      });
                    }}
                    errorText={AreFieldsValidated && isEmpty(fields.Area)}
                    disabled={prerequisiteValue.disabledArea}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomFormSelect
                    inputType="text"
                    label="Inquiry"
                    value={fields.Inquiry}
                    menu={[inquiryMenu]}
                    customClassName={classes.textFieldSelectStyling}
                    onChange={(event) => {
                      setFields({
                        ...fields,
                        Inquiry: event.target.value,
                      });
                    }}
                    errorText={AreFieldsValidated && isEmpty(fields.Inquiry)}
                    disabled
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomFormSelect
                    inputType="text"
                    required
                    label="Question Type"
                    value={fields.Type}
                    menu={INPUT_TYPES}
                    customClassName={classes.textFieldSelectStyling}
                    onChange={(event) => {
                      setFields({
                        ...fields,
                        Type: event.target.value,
                      });
                    }}
                    errorText={AreFieldsValidated && isEmpty(fields.Type)}
                    disabled={
                      (fields.Area && fields.Area !== "Other") ||
                      prerequisiteValue.disabled
                    }
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    inputType="text"
                    required
                    label="Question Title"
                    value={fields.Title}
                    onChange={(event) => {
                      setFields({
                        ...fields,
                        Title: event.target.value,
                      });
                    }}
                    errorText={AreFieldsValidated && isEmpty(fields.Title)}
                    disabled={prerequisiteValue.disabled}
                  />
                </GridItem>
                {fields.Type.toLocaleLowerCase() === "textbox" ? (
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      inputType="text"
                      required
                      label="Max. Length"
                      value={fields.MaxLength}
                      onChange={(event) => {
                        setFields({
                          ...fields,
                          MaxLength: event.target.value,
                        });
                      }}
                      errorText={
                        AreFieldsValidated && isNumber(fields.MaxLength)
                      }
                      disabled={prerequisiteValue.disabled}
                    />
                  </GridItem>
                ) : null}
                {fields.Type.toLocaleLowerCase() === "textbox" ? (
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomFormSelect
                      inputType="text"
                      required
                      label="Validation Regex"
                      value={fields.ValidationRegex}
                      menu={INPUT_VALIDATIONS}
                      customClassName={classes.textFieldSelectStyling}
                      onChange={(event) => {
                        setFields({
                          ...fields,
                          ValidationRegex: event.target.value,
                        });
                      }}
                      errorText={
                        AreFieldsValidated && isEmpty(fields.ValidationRegex)
                      }
                      disabled={prerequisiteValue.disabled}
                    />
                  </GridItem>
                ) : null}
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    inputType="text"
                    required
                    label="Question Detail"
                    multiline
                    value={fields.Description}
                    onChange={(event) => {
                      setFields({
                        ...fields,
                        Description: event.target.value,
                      });
                    }}
                    errorText={
                      AreFieldsValidated && isEmpty(fields.Description)
                    }
                    disabled={prerequisiteValue.disabled}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    inputType="text"
                    label="Added By"
                    value={fields.AddedBy}
                    onChange={(event) => {
                      setFields({
                        ...fields,
                        AddedBy: event.target.value,
                      });
                    }}
                    customClassName={classes.textFieldSelectStyling}
                    errorText={AreFieldsValidated && isEmpty(fields.AddedBy)}
                    disabled
                  />
                </GridItem>

                {fields.Type.toLowerCase() === "rating" ||
                fields.Type.toLowerCase() === "checkbox" ? (
                  <GridItem xs={12} sm={12} md={12}>
                    <InputOptions
                      options={
                        fields.Type.toLowerCase() === "rating"
                          ? fields.RadioButtonOptions
                          : fields.Type.toLowerCase() === "checkbox"
                          ? fields.CheckBoxOptions
                          : []
                      }
                      fields={fields}
                      setFields={setFields}
                      disabled={prerequisiteValue.disabled}
                      shouldValidateFields={AreFieldsValidated}
                      errorText={
                        AreFieldsValidated &&
                        isEmpty(
                          fields.Type.toLowerCase() === "rating"
                            ? fields.RadioButtonOptions
                            : fields.CheckBoxOptions
                        )
                      }
                    />
                  </GridItem>
                ) : null}
                {prerequisiteValue.disabledArea && isedit ? (
                  <GridItem xs={12} sm={12} md={6}>
                    <strong style={{ color: "#FF0000" }}>
                      Note: Can not change the area due to the{" "}
                      {fields.Type.toLowerCase()} question type.
                    </strong>
                  </GridItem>
                ) : null}
              </GridContainer>
            </Form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default CustomMetricsFields;
